import React from "react";

/**
 * Maillot dos IPHB floqué — affiche le maillot officiel avec, en surimpression,
 * le NOM de l'entreprise (haut, entre les épaules) et le NUMÉRO 13 (centre du dos).
 * Effet "sortir de la page" : le bas du maillot s'efface en gradient.
 *
 * Props :
 *  - companyName : string (nom de l'entreprise floqué)
 *  - number      : number  (numéro de maillot, default 13)
 *  - className   : string (classes Tailwind additionnelles)
 */
export default function JerseyBackBadge({ companyName = "", number = 13, className = "", style: extraStyle = {} }) {
  const display = (companyName || "").trim().toUpperCase();
  const len = display.length;
  // Toujours 1 seule ligne — on adapte la taille de police selon la longueur
  let nameFontSize = "clamp(0.95rem, 1.55vw, 1.5rem)";
  if (len > 22) nameFontSize = "clamp(0.55rem, 0.85vw, 0.8rem)";
  else if (len > 16) nameFontSize = "clamp(0.65rem, 1vw, 0.95rem)";
  else if (len > 10) nameFontSize = "clamp(0.8rem, 1.25vw, 1.2rem)";
  return (
    <div
      className={`pointer-events-none select-none ${className}`}
      style={{
        WebkitMaskImage:
          "linear-gradient(to bottom, black 0%, black 55%, rgba(0,0,0,0.6) 75%, transparent 100%)",
        maskImage:
          "linear-gradient(to bottom, black 0%, black 55%, rgba(0,0,0,0.6) 75%, transparent 100%)",
        ...extraStyle,
      }}
      data-testid="jersey-back-badge"
    >
      <div className="relative w-full">
        <img
          src="/brands/maillot-dos-iphb.png"
          alt="Maillot IPHB dos"
          className="block w-full h-auto"
          style={{ filter: "drop-shadow(0 14px 24px rgba(0,0,0,0.55))" }}
          draggable={false}
        />

        {/* Flocage NOM ENTREPRISE — entre les épaules (style maillot pro). Multi-ligne si trop long. */}
        {display && (
          <div
            className="absolute left-1/2 -translate-x-1/2 text-center w-[68%]"
            style={{ top: "27%" }}
          >
            <span
              className="block whitespace-nowrap overflow-hidden text-ellipsis"
              style={{
                fontFamily: "'Bebas Neue', 'Impact', sans-serif",
                fontWeight: 700,
                color: "#e9c878",
                fontSize: nameFontSize,
                letterSpacing: "0.14em",
                textShadow:
                  "0 1px 2px rgba(0,0,0,0.85), 0 0 6px rgba(233,200,120,0.35)",
                lineHeight: 1.05,
              }}
            >
              {display}
            </span>
          </div>
        )}

        {/* Numéro 13 — centre du dos (taille XL) */}
        <div
          className="absolute left-1/2 -translate-x-1/2"
          style={{ top: "35%" }}
        >
          <span
            className="block"
            style={{
              fontFamily: "'Bebas Neue', 'Impact', sans-serif",
              fontWeight: 700,
              color: "#e9c878",
              fontSize: "clamp(3rem, 9vw, 7rem)",
              letterSpacing: "0.01em",
              lineHeight: 0.95,
              textShadow:
                "0 3px 6px rgba(0,0,0,0.85), 0 0 12px rgba(233,200,120,0.35)",
            }}
          >
            {number}
          </span>
        </div>
      </div>
    </div>
  );
}
